import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import Dashboard from "@/pages/Dashboard";
import SiteAudit from "@/pages/SiteAudit";
import LocalRank from "@/pages/LocalRank";
import MetaGenerator from "@/pages/MetaGenerator";
import SchemaGenerator from "@/pages/SchemaGenerator";
import RobotsChecker from "@/pages/RobotsChecker";
import LlmsGenerator from "@/pages/LlmsGenerator";
import IndexNow from "@/pages/IndexNow";
import LinkTools from "@/pages/LinkTools";
import Auth from "@/pages/Auth";
import MyAudits from "@/pages/MyAudits";

function App() {
  return (
    <LangProvider>
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/site-audit" element={<SiteAudit />} />
            <Route path="/local-rank" element={<LocalRank />} />
            <Route path="/meta-generator" element={<MetaGenerator />} />
            <Route path="/schema-generator" element={<SchemaGenerator />} />
            <Route path="/robots-checker" element={<RobotsChecker />} />
            <Route path="/llms-txt" element={<LlmsGenerator />} />
            <Route path="/indexnow" element={<IndexNow />} />
            <Route path="/link-tools" element={<LinkTools />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/my-audits" element={<MyAudits />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
    </LangProvider>
  );
}

export default App;
